import { Skeleton } from '@/components/atoms/Skeleton';
import { ReactNode } from 'react';
import DrawerFallback from '../../Drawer/fallback';
import { theme } from '@/styles/theme';

interface PaginaVendaMobileFallbackProps {
  $fallbackConteudoDescritivo: ReactNode;
}

export const CheckoutContainerFallback = () => (
  <DrawerFallback
    style={{
      padding: theme.spacing[4],
      backgroundColor: theme.panel.solid,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing[4],
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Skeleton style={{ height: 32, width: 100 }} />
        <Skeleton style={{ height: 24, width: 62 }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          gap: theme.spacing[2],
        }}
      >
        <Skeleton style={{ height: 40, width: 40 }} />
        <Skeleton style={{ height: 40, flex: 1 }} />
      </div>
    </div>
  </DrawerFallback>
);

export default function PaginaVendaMobileFallback(
  props: PaginaVendaMobileFallbackProps,
) {
  const { $fallbackConteudoDescritivo } = props;
  return (
    <div style={{ minHeight: '100vh' }}>
      <Skeleton style={{ height: 32, borderRadius: 'none' }} />
      <div>
        <Skeleton
          style={{
            height: 200,
            backgroundColor: theme.colors.neutral.neutral_alpha[3],
          }}
        />
        {$fallbackConteudoDescritivo}
      </div>
    </div>
  );
}
